// import React, { useEffect, useMemo, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Search, RotateCcw, FileSpreadsheet, ChevronUp, ChevronDown } from 'lucide-react';

// import IsoDateInput from '../../components/common/Isodateinput';
// import { fetchOTDetails } from '../../store/slices/overtimeSlice';
// import { mapOTRows } from '../../utils/overtimeAnalytics';
// import { exportOTRecordsToExcel } from '../../utils/otExcel';

// const FIELD =
//   'w-full h-9 bg-white border border-gray-200 rounded-lg text-xs px-2.5 outline-none focus:border-primary-500 text-gray-700';
// const LABEL = 'text-[11px] font-medium text-gray-500 mb-1 block';

// // `group: true` starts a new column group — marked by extra left padding, not a line.
// const COLUMNS = [
//   { key: 'id',          label: 'OT ID',    align: 'center',   width: '72px'  },
//   { key: 'employeeId',  label: 'Employee', align: 'center',   width: '92px'  },
//   { key: 'date',        label: 'Date',     align: 'center',   width: '124px', group: true },
//   { key: 'weekday',     label: 'Day',      align: 'left',   width: '100px' },
//   { key: 'shiftId',     label: 'Shift',    align: 'center', width: '64px'  },
//   { key: 'inTime',      label: 'In',       align: 'center',  width: '86px',  group: true },
//   { key: 'outTime',     label: 'Out',      align: 'center',  width: '88px'  },
//   { key: 'normalHours', label: 'Normal',   align: 'right',  width: '98px',  group: true },
//   { key: 'otHours',     label: 'OT',       align: 'right',  width: '78px'  },
//   { key: 'totalHours',  label: 'Total',    align: 'right',  width: '84px'  },
//   { key: 'otTypeLabel', label: 'OT Type',  align: 'left',   width: '146px', group: true },
//   { key: 'otAmount',    label: 'Amount',   align: 'right',  width: '92px',  hideWhenEmpty: 'otAmount' },
//   { key: 'active',      label: 'Status',   align: 'center',   width: '92px'  },
// ];

// const alignCls = (a) => (a === 'right' ? 'text-right' : a === 'center' ? 'text-center' : 'text-center');

// // Premium-rate overtime is the only thing worth colouring.
// const PREMIUM_TYPES = ['SUNDAY', 'HOLIDAY', 'POYA'];
// const isPremium = (t) => PREMIUM_TYPES.includes(t);

// // Keep zeros present but recessive so real figures carry the eye.
// function Num({ value, strong = false }) {
//   const n = Number(value) || 0;
//   if (n === 0) return <span className="text-gray-300">0.00</span>;
//   return <span className={strong ? 'font-semibold text-gray-900' : 'text-gray-600'}>{n.toFixed(2)}</span>;
// }

// export default function OTDetails() {
//   const dispatch = useDispatch();
//   const { rows, loading, error } = useSelector((s) => s.overtime);

//   // Server-side filters
//   const [employeeId, setEmployeeId] = useState('');
//   const [attDay, setAttDay] = useState('');

//   // Client-side filters
//   const [typeFilter, setTypeFilter] = useState('All');
//   const [shiftFilter, setShiftFilter] = useState('All');
//   const [statusFilter, setStatusFilter] = useState('All');
//   const [minOT, setMinOT] = useState('');
//   const [search, setSearch] = useState('');

//   const [sort, setSort] = useState({ key: 'date', dir: 'desc' });

//   useEffect(() => {
//     dispatch(fetchOTDetails({}));
//   }, [dispatch]);

//   const handleSearch = () =>
//     dispatch(fetchOTDetails({ employeeId: employeeId.trim(), attDay: attDay.trim() }));

//   const handleReset = () => {
//     setEmployeeId('');
//     setAttDay('');
//     setTypeFilter('All');
//     setShiftFilter('All');
//     setStatusFilter('All');
//     setMinOT('');
//     setSearch('');
//     dispatch(fetchOTDetails({}));
//   };

//   const mapped = useMemo(() => mapOTRows(rows), [rows]);

//   const typeOptions = useMemo(
//     () => Array.from(new Set(mapped.map((r) => r.otTypeLabel).filter(Boolean))).sort(),
//     [mapped]
//   );
//   const shiftOptions = useMemo(
//     () => Array.from(new Set(mapped.map((r) => r.shiftId).filter(Boolean))).sort(),
//     [mapped]
//   );

//   const filtered = useMemo(() => {
//     const min = parseFloat(minOT);
//     const term = search.trim().toLowerCase();

//     return mapped.filter((r) => {
//       if (typeFilter !== 'All' && r.otTypeLabel !== typeFilter) return false;
//       if (shiftFilter !== 'All' && r.shiftId !== shiftFilter) return false;
//       if (statusFilter === 'Active' && !r.active) return false;
//       if (statusFilter === 'Inactive' && r.active) return false;
//       if (!Number.isNaN(min) && r.otHours < min) return false;
//       if (term) {
//         const haystack = `${r.id} ${r.employeeId} ${r.date} ${r.weekday} ${r.otTypeLabel}`.toLowerCase();
//         if (!haystack.includes(term)) return false;
//       }
//       return true;
//     });
//   }, [mapped, typeFilter, shiftFilter, statusFilter, minOT, search]);

//   const sorted = useMemo(() => {
//     const list = [...filtered];
//     const { key, dir } = sort;
//     const mult = dir === 'asc' ? 1 : -1;
//     list.sort((a, b) => {
//       const av = a[key];
//       const bv = b[key];
//       if (typeof av === 'number' && typeof bv === 'number') return (av - bv) * mult;
//       if (typeof av === 'boolean') return ((av === bv) ? 0 : av ? 1 : -1) * mult;
//       return String(av ?? '').localeCompare(String(bv ?? '')) * mult;
//     });
//     return list;
//   }, [filtered, sort]);

//   const toggleSort = (key) =>
//     setSort((prev) => (prev.key === key
//       ? { key, dir: prev.dir === 'asc' ? 'desc' : 'asc' }
//       : { key, dir: 'asc' }));

//   const totals = useMemo(() => {
//     const r2 = (n) => Math.round(n * 100) / 100;
//     return {
//       normal: r2(sorted.reduce((s, r) => s + r.normalHours, 0)),
//       ot:     r2(sorted.reduce((s, r) => s + r.otHours, 0)),
//       total:  r2(sorted.reduce((s, r) => s + r.totalHours, 0)),
//     };
//   }, [sorted]);

//   // A column that is empty in every row is dead space — leave it out.
//   const columns = useMemo(
//     () => COLUMNS.filter((c) => {
//       if (!c.hideWhenEmpty) return true;
//       return sorted.some((r) => r[c.hideWhenEmpty] !== null && r[c.hideWhenEmpty] !== undefined && r[c.hideWhenEmpty] !== '');
//     }),
//     [sorted]
//   );

//   const showAmount = columns.some((c) => c.key === 'otAmount');

//   const handleExport = () => {
//     exportOTRecordsToExcel({
//       rows: sorted,
//       filters: {
//         'Employee ID': employeeId || 'All',
//         'Date': attDay || 'All',
//         'OT Type': typeFilter,
//         'Shift': shiftFilter,
//         'Status': statusFilter,
//         'Min OT Hrs': minOT || 'None',
//         'Search': search || 'None',
//       },
//     });
//   };

//   return (
//     <div className="p-6 space-y-4">
//       {/* ── Header ─────────────────────────────────────────────── */}
//       <div className="flex flex-wrap items-end justify-between gap-3">
//         <div>
//           <p className="text-xs text-gray-400">Overtime Management <span className="mx-1">/</span> Overtime Details</p>
//           <h2 className="text-2xl font-bold text-gray-900 mt-0.5">Overtime Details</h2>
//         </div>
//         <button
//           onClick={handleExport}
//           disabled={sorted.length === 0}
//           className="flex items-center gap-2 h-9 px-4 bg-emerald-600 text-white rounded-lg text-xs font-semibold hover:bg-emerald-700 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
//         >
//           <FileSpreadsheet size={15} />
//           Export to Excel
//         </button>
//       </div>

//       {/* ── Filters ────────────────────────────────────────────── */}
//       <div className="bg-white border border-gray-100 rounded-xl px-4 py-3.5 shadow-sm space-y-3">
//         <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
//           <div>
//             <span className={LABEL}>Employee ID</span>
//             <input
//               type="text"
//               value={employeeId}
//               placeholder="e.g. 2022"
//               onChange={(e) => setEmployeeId(e.target.value)}
//               onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
//               className={FIELD}
//             />
//           </div>
//           <div>
//             <span className={LABEL}>Attendance Date</span>
//             <IsoDateInput value={attDay} onChange={setAttDay} onEnter={handleSearch} className={FIELD} />
//           </div>
//           <div className="flex items-end gap-2 md:col-span-2">
//             <button
//               onClick={handleSearch}
//               disabled={loading}
//               className="flex items-center gap-2 h-9 px-4 bg-primary-600 text-white rounded-lg text-xs font-semibold hover:bg-primary-700 transition-colors disabled:opacity-50"
//             >
//               <Search size={14} />
//               {loading ? 'Loading...' : 'Search'}
//             </button>
//             <button
//               onClick={handleReset}
//               className="flex items-center gap-2 h-9 px-3 bg-gray-100 text-gray-600 rounded-lg text-xs font-semibold hover:bg-gray-200 transition-colors"
//             >
//               <RotateCcw size={14} />
//               Reset
//             </button>
//           </div>
//         </div>

//         <div className="grid grid-cols-2 md:grid-cols-5 gap-3 pt-3 border-t border-gray-100">
//           <div>
//             <span className={LABEL}>OT Type</span>
//             <select value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)} className={FIELD}>
//               <option value="All">All</option>
//               {typeOptions.map((t) => <option key={t} value={t}>{t}</option>)}
//             </select>
//           </div>
//           <div>
//             <span className={LABEL}>Shift</span>
//             <select value={shiftFilter} onChange={(e) => setShiftFilter(e.target.value)} className={FIELD}>
//               <option value="All">All</option>
//               {shiftOptions.map((s) => <option key={s} value={s}>{s}</option>)}
//             </select>
//           </div>
//           <div>
//             <span className={LABEL}>Status</span>
//             <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} className={FIELD}>
//               <option value="All">All</option>
//               <option value="Active">Active</option>
//               <option value="Inactive">Inactive</option>
//             </select>
//           </div>
//           <div>
//             <span className={LABEL}>Min OT Hrs</span>
//             <input
//               type="number"
//               min="0"
//               step="0.5"
//               value={minOT}
//               placeholder="e.g. 2"
//               onChange={(e) => setMinOT(e.target.value)}
//               className={FIELD}
//             />
//           </div>
//           <div>
//             <span className={LABEL}>Search</span>
//             <input
//               type="text"
//               value={search}
//               placeholder="ID, employee, date..."
//               onChange={(e) => setSearch(e.target.value)}
//               className={FIELD}
//             />
//           </div>
//         </div>

//         <p className="text-[11px] text-gray-400">
//           Employee ID and Date query the server. The remaining filters refine the loaded results.
//         </p>
//       </div>

//       {error && (
//         <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">{error}</div>
//       )}

//       {/* ── Records ────────────────────────────────────────────── */}
//       <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
//         <div className="px-5 py-3.5 border-b border-gray-200 flex items-center justify-between">
//           <h3 className="text-sm font-semibold text-gray-900">OT Records</h3>
//           <span className="text-xs text-gray-500">
//             {sorted.length} of {mapped.length} record{mapped.length === 1 ? '' : 's'}
//           </span>
//         </div>

//         {loading ? (
//           <div className="py-20 text-center text-sm text-gray-400">Loading overtime details...</div>
//         ) : sorted.length === 0 ? (
//           <div className="py-20 text-center text-sm text-gray-400">No overtime records found</div>
//         ) : (
//           <div className="overflow-auto max-h-[calc(100vh-380px)] min-h-[240px]">
//             <table className="w-full text-[13px]" style={{ minWidth: 1060 }}>
//               <colgroup>
//                 {columns.map((c) => <col key={c.key} style={{ width: c.width }} />)}
//               </colgroup>

//               <thead className="sticky top-0 z-10">
//                 <tr className="bg-gray-50 border-b border-gray-200">
//                   {columns.map((c) => {
//                     const active = sort.key === c.key;
//                     return (
//                       <th
//                         key={c.key}
//                         onClick={() => toggleSort(c.key)}
//                         title={`Sort by ${c.label}`}
//                         className={`px-4 py-3 text-[12px] font-semibold whitespace-nowrap
//                           cursor-pointer select-none transition-colors hover:text-gray-900
//                           ${alignCls(c.align)}
//                           ${active ? 'text-gray-900' : 'text-gray-500'}`}
//                       >
//                         <span className={`inline-flex items-center gap-1 ${c.align === 'right' ? 'flex-row-reverse' : ''}`}>
//                           {c.label}
//                           {active && (sort.dir === 'asc'
//                             ? <ChevronUp size={12} className="text-primary-600" />
//                             : <ChevronDown size={12} className="text-primary-600" />)}
//                         </span>
//                       </th>
//                     );
//                   })}
//                 </tr>
//               </thead>

//               <tbody>
//                 {sorted.map((r) => (
//                   <tr key={r.id} className="border-b border-gray-100 last:border-0 hover:bg-gray-50 transition-colors">
//                     <td className="px-4 py-3 text-center text-gray-400 tabular-nums">{r.id}</td>
//                     <td className="px-4 py-3 text-center font-semibold text-gray-900 tabular-nums">{r.employeeId}</td>

//                     <td className="px-4 py-3 text-center text-gray-900 tabular-nums whitespace-nowrap">
//                       {r.date || '—'}
//                     </td>
//                     <td className="px-4 py-3 text-center text-gray-500">{r.weekday || '—'}</td>
//                     <td className="px-4 py-3 text-center text-gray-500 tabular-nums">{r.shiftId || '—'}</td>

//                     <td className="px-4 py-3 text-center text-gray-600 tabular-nums">
//                       {r.inTime || '—'}
//                     </td>
//                     <td className="px-4 py-3 text-center text-gray-600 tabular-nums whitespace-nowrap">
//                       {r.outTime || '—'}
//                       {/* {r.overnight && <span className="ml-1 text-[11px] text-gray-400">+1d</span>} */}
//                     </td>

//                     <td className="px-4 py-3 text-right tabular-nums">
//                       <Num value={r.normalHours} />
//                     </td>
//                     <td className="px-4 py-3 text-right tabular-nums">
//                       <Num value={r.otHours} strong />
//                     </td>
//                     <td className="px-4 py-3 text-right tabular-nums">
//                       <Num value={r.totalHours} />
//                     </td>

//                     <td className={`px-4 py-3 whitespace-nowrap ${
//                       isPremium(r.otType) ? 'text-amber-700 font-medium' : 'text-gray-600'
//                     }`}>
//                       {r.otTypeLabel}
//                     </td>

//                     {showAmount && (
//                       <td className="px-4 py-3 text-right tabular-nums text-gray-600">
//                         {r.otAmount === null ? <span className="text-gray-300">—</span> : r.otAmount.toFixed(2)}
//                       </td>
//                     )}

//                     <td className="px-4 py-3 text-center">
//                       <span
//                         className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-semibold ${
//                           r.active
//                             ? 'bg-emerald-50 text-emerald-700'
//                             : 'bg-gray-100 text-gray-500'
//                         }`}
//                       >
//                         <span className={`w-1.5 h-1.5 rounded-full ${r.active ? 'bg-emerald-500' : 'bg-gray-400'}`} />
//                         {r.active ? 'Active' : 'Inactive'}
//                       </span>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>

//               <tfoot className="sticky bottom-0">
//                 <tr className="bg-gray-50 border-t border-gray-300 text-gray-900">
//                   <td className="px-4 py-3 text-[12px] font-semibold text-gray-500" colSpan={7}>
//                     Total · {sorted.length} record{sorted.length === 1 ? '' : 's'}
//                   </td>
//                   <td className="px-4 py-3 text-right tabular-nums text-gray-600">
//                     {totals.normal.toFixed(2)}
//                   </td>
//                   <td className="px-4 py-3 text-right tabular-nums font-semibold">{totals.ot.toFixed(2)}</td>
//                   <td className="px-4 py-3 text-right tabular-nums text-gray-600">{totals.total.toFixed(2)}</td>
//                   <td className="px-4 py-3" colSpan={showAmount ? 3 : 2} />
//                 </tr>
//               </tfoot>
//             </table>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }





import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Search, RotateCcw, FileSpreadsheet, CheckCircle, Loader2, Check, Info,
  ChevronUp, ChevronDown, ChevronsUpDown,
} from 'lucide-react';

import Breadcrumb, { BREADCRUMB_EXPORT_BTN } from '../../components/Breadcrumb/Breadcrumb';
import {
  fetchOTDetailsWithStatus,
  approveOTRecord,
  bulkApproveOTRecords,
  clearBulkApprovalResult,
} from '../../store/slices/overtimeSlice';
import { fetchAllEmployees } from '../../store/slices/employeeSlice';
import { mapOTRows } from '../../utils/overtimeAnalytics';
import { exportOTRecordsToExcel } from '../../utils/otExcel';
import EmployeeSearch from '../../components/common/EmployeeSearch';

import { createPortal } from 'react-dom';

const FIELD =
  'w-full h-9 bg-white border border-gray-200 rounded-lg text-xs px-2.5 outline-none focus:border-primary-500 text-gray-700';
const LABEL = 'text-[11px] font-medium text-gray-500 mb-1 block';

/* Raw decimal hours*/
const fmtH = (v) => {
  const n = Number(v);
  if (!Number.isFinite(n) || n <= 0) return '—';
  return `${Number(n.toFixed(2))} h`;
};

const STICKY_TOP = -24;
const STICKY_BOTTOM = -24;

/* Status badge */
const StatusBadge = ({ isApproved }) =>
  isApproved ? (
    <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
      Approved
    </span>
  ) : (
    <span className="px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
      Pending
    </span>
  );

const TABS = ['All', 'Pending', 'Approved'];


function InfoTip({ children }) {
  const [open, setOpen] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);

  const handleEnter = () => {
    const rect = triggerRef.current?.getBoundingClientRect();
    if (rect) setCoords({ top: rect.bottom + 8, left: rect.right });
    setOpen(true);
  };
  const handleLeave = () => setOpen(false);

  return (
    <>
      <span
        ref={triggerRef}
        className="inline-flex items-center"
        onMouseEnter={handleEnter}
        onMouseLeave={handleLeave}
      >
        <Info size={12} className="text-slate-400 hover:text-slate-600 cursor-help ml-1" />
      </span>
      {open &&
        createPortal(
          <span
            role="tooltip"
            className="pointer-events-none fixed z-[9999] w-64 -translate-x-full
                       rounded-lg bg-slate-900 text-white text-[11px] leading-snug font-normal
                       px-3 py-2 shadow-lg normal-case tracking-normal text-left"
            style={{ top: coords.top, left: coords.left }}
          >
            {children}
            <span className="absolute right-3 -top-1 w-2 h-2 bg-slate-900 rotate-45" />
          </span>,
          document.body
        )}
    </>
  );
}

/* Columns  */
const COLUMNS = [
  { key: 'select', label: '', align: 'center', width: 56, sticky: true, left: 0, sortable: false },
  { key: 'employeeName', label: 'Employee', align: 'left', width: 300, sticky: true, left: 56 },
  { key: 'date', label: 'Date', align: 'center', width: 130, sticky: true, left: 356 },
  { key: 'shiftName', label: 'Shift Type', align: 'center', width: 140 },
  { key: 'otTypeLabel', label: 'OT Type', align: 'center', width: 140 },
  { key: 'inTime', label: 'In Time', align: 'center', width: 100 },
  { key: 'outTime', label: 'Out Time', align: 'center', width: 100 },
  {
    key: 'otHours',
    label: 'OT Hours',
    align: 'center',
    width: 120,
    info: (
      <>
        <span className="font-semibold">OT Hours Rate</span> — total overtime hours worked beyond
        the standard shift.
      </>
    ),
  },
  {
    key: 'HOT_OTHOURS_RATE',
    label: 'OT Hours Rate',
    align: 'center',
    width: 140,
    info: (
      <>
        <span className="font-semibold">OT Hours Rate</span> — the multiplier applied to OT Hours.
      </>
    ),
  },
  {
    key: 'HOT_ADJUSTED_OT_HOURS',
    label: 'Adjusted OT Hours',
    align: 'center',
    width: 160,
    info: (
      <>
        <span className="font-semibold">Adjusted OT Hours</span> = OT Hours × OT Hours Rate
      </>
    ),
  },
  {
    key: 'otRate',
    label: 'OT Rate',
    align: 'center',
    width: 120,
    info: (
      <>
        <span className="font-semibold">OT Rate</span> — the hourly pay rate used for OT.
      </>
    ),
  },
  {
    key: 'otAmount',
    label: 'OT Amount',
    align: 'center',
    width: 130,
    info: (
      <>
        <span className="font-semibold">OT Amount</span> = Adjusted OT Hours × OT Rate
      </>
    ),
  },
  { key: 'status', sortKey: 'isApproved', label: 'Status', align: 'center', width: 120 },
  { key: 'actions', label: 'Actions', align: 'center', width: 140, sortable: false },
];

const TABLE_MIN_WIDTH = COLUMNS.reduce((s, c) => s + c.width, 0);
const ALIGN = { left: 'text-left', center: 'text-center', right: 'text-right' };
const stickyStyle = (col) => (col.sticky ? { position: 'sticky', left: col.left } : undefined);

export default function OTDetails() {
  const dispatch = useDispatch();
  const {
    rows, pendingRows, approvedRows, loading, approving,
    error, approvalError, bulkApprovalResult,
  } = useSelector((s) => s.overtime);

  const { employees: reduxEmployees, loading: employeesLoading } =
    useSelector((s) => s.employees || { employees: [], loading: false });

  const currentUserId = useSelector((s) => s.auth?.user?.employeeId || '0004086');

  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const [employeeId, setEmployeeId] = useState('');
  const [attMonth, setAttMonth] = useState('');
  const [activeTab, setActiveTab] = useState('Pending');
  const [typeFilter, setTypeFilter] = useState('All');
  const [search, setSearch] = useState('')

  const [selectedRows, setSelectedRows] = useState([]);
  const [sort, setSort] = useState({ key: 'date', dir: 'desc' });


  const [dateMode, setDateMode] = useState('month');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');


  const ALL_EMPLOYEES = '__ALL__';
  const isAllEmployees = (emp) => {
    if (!emp) return false;
    const id = String(emp.employeeId ?? '').trim();
    return !id || id.toUpperCase() === ALL_EMPLOYEES;
  };
  const resolveEmployeeId = () => {
    if (selectedEmployee && !isAllEmployees(selectedEmployee)) {
      return String(selectedEmployee.employeeId).trim();
    }
    const raw = employeeId.trim();
    return raw && raw.toUpperCase() !== ALL_EMPLOYEES ? raw : '';
  };

  /* Load employees */
  useEffect(() => { dispatch(fetchAllEmployees()); }, [dispatch]);

  useEffect(() => {
    if (reduxEmployees && Array.isArray(reduxEmployees) && reduxEmployees.length > 0) {
      const normalizedEmployees = reduxEmployees.map((emp) => ({
        employeeId: String(emp.HED_EMPLOYEE_ID || emp.HED_SERVICE_NO || ''),
        serviceNo: emp.HED_SERVICE_NO || '',
        name:
          emp.HED_REPORT_NAME ||
          `${emp.HED_FIRST_NAME || ''} ${emp.HED_LAST_NAME || ''}`.trim() ||
          `Employee ${emp.HED_SERVICE_NO}`,
        department: emp.HDD_DEPARTMENT_NAME || '',
        location: emp.HED_LOCATION_ID || '',
        firstName: emp.HED_FIRST_NAME || '',
        lastName: emp.HED_LAST_NAME || '',
        reportName: emp.HED_REPORT_NAME || '',
        shiftName: (emp.HSD_SHIFT_NAME || '').trim(),
      })).filter((emp) => emp.employeeId);
      setEmployees(normalizedEmployees);
    }
  }, [reduxEmployees]);

  /* Auto-fetch on server-side filter change */
  useEffect(() => {
    const filterParams = {};
    const empId = resolveEmployeeId();
    if (empId) filterParams.employeeId = empId;
    if (attMonth.trim()) filterParams.attDay = `${attMonth.trim()}-01`;
    if (!filterParams.employeeId && !filterParams.attDay) return;
    setSelectedRows([]);
    dispatch(fetchOTDetailsWithStatus(filterParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEmployee, attMonth, dispatch]);


  const buildFilterParams = () => {
    const params = {};
    const empId = resolveEmployeeId();
    if (empId) params.employeeId = empId;

    if (dateMode === 'month') {
      if (!attMonth.trim()) return null;
      params.attDay = `${attMonth.trim()}-01`;
    } else {
      if (!dateFrom || !dateTo || dateFrom > dateTo) return null;
      params.fromDate = dateFrom;
      params.toDate = dateTo;
    }
    return params;
  };


  /* Auto-fetch on server-side filter change */
  useEffect(() => {
    const params = buildFilterParams();
    if (!params) return;
    setSelectedRows([]);
    dispatch(fetchOTDetailsWithStatus(params));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEmployee, dateMode, attMonth, dateFrom, dateTo, dispatch]);

  /* Default current month */
  useEffect(() => {
    const now = new Date();
    const currentMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    setAttMonth(currentMonth);

    const { from, to } = defaultRange();
    setDateFrom(from);
    setDateTo(to);
  }, []);

  const handleSearch = () => {
    const params = buildFilterParams();
    if (!params) return;
    setSelectedRows([]);
    dispatch(fetchOTDetailsWithStatus(params));
  };

  const handleReset = () => {
    setEmployeeId('');
    setSelectedEmployee(null);
    setDateMode('month');
    setAttMonth('');
    const { from, to } = defaultRange();
    setDateFrom(from);
    setDateTo(to);
    setActiveTab('Pending');
    setTypeFilter('All');
    setSearch('');
    setSelectedRows([]);
    dispatch(clearBulkApprovalResult());
  };

  const getFilteredRows = () => {
    switch (activeTab) {
      case 'Pending': return pendingRows;
      case 'Approved': return approvedRows;
      default: return rows;
    }
  };

  const currentRows = getFilteredRows();

  const mapped = useMemo(() => {
    const base = mapOTRows(currentRows, employees);

    const rawById = new Map();
    (currentRows || []).forEach((raw, idx) => {
      const id = raw?.HOT_OVERTIME_ID ?? raw?.id ?? idx;
      if (id != null) rawById.set(String(id), raw);
    });

    const mergedBase = base.map((row, idx) => {
      const raw =
        rawById.get(String(row.otId ?? row.id)) ||
        (currentRows && currentRows[idx]) ||
        {};
      return { ...raw, ...row };
    });

    if (!employees || employees.length === 0) return mergedBase;

    const shiftById = new Map();
    const shiftByServiceNo = new Map();
    employees.forEach((emp) => {
      const shift = emp.shiftName || '';
      if (emp.employeeId) shiftById.set(String(emp.employeeId), shift);
      if (emp.serviceNo) shiftByServiceNo.set(String(emp.serviceNo), shift);
    });

    return mergedBase.map((row) => {
      const key = String(row.employeeId ?? '').trim();
      const shift = shiftById.get(key) || shiftByServiceNo.get(key) || '';
      return { ...row, shiftName: shift };
    });
  }, [currentRows, employees]);

  const typeOptions = useMemo(
    () => Array.from(new Set(mapped.map((r) => r.otTypeLabel).filter(Boolean))).sort(),
    [mapped]
  );

  const filtered = useMemo(() => {
    const term = search.trim().toLowerCase();
    return mapped.filter((r) => {
      if (typeFilter !== 'All' && r.otTypeLabel !== typeFilter) return false;
      if (term) {
        const haystack = `${r.id} ${r.employeeId} ${r.employeeName} ${r.date} ${r.otTypeLabel}`.toLowerCase();
        if (!haystack.includes(term)) return false;
      }
      return true;
    });
  }, [mapped, typeFilter, search]);

  /* sorted */
  const sorted = useMemo(() => {
    const list = [...filtered];
    const { key, dir } = sort;
    const mult = dir === 'asc' ? 1 : -1;
    list.sort((a, b) => {
      const av = a[key];
      const bv = b[key];
      if (typeof av === 'number' && typeof bv === 'number') return (av - bv) * mult;
      if (typeof av === 'boolean') return (av === bv ? 0 : av ? 1 : -1) * mult;
      return String(av ?? '').localeCompare(String(bv ?? '')) * mult;
    });
    return list;
  }, [filtered, sort]);

  const approvableRows = useMemo(() => sorted.filter((r) => !r.isApproved), [sorted]);
  const allApprovableSelected =
    approvableRows.length > 0 && approvableRows.every((r) => selectedRows.includes(r.id));

  const defaultRange = () => {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, '0');
    const d = String(now.getDate()).padStart(2, '0');
    return { from: `${y}-${m}-01`, to: `${y}-${m}-${d}` };
  };

  /* ───────── Scroll plumbing (mirrors AttendanceSummary) ───────── */
  const tableScrollRef = useRef(null);
  const barRef = useRef(null);
  const headerRef = useRef(null);
  const syncing = useRef(false);
  const [bar, setBar] = useState({ scrollWidth: 0, hasOverflow: false });

  const measureBar = useCallback(() => {
    const el = tableScrollRef.current;
    if (!el) return;
    const next = {
      scrollWidth: el.scrollWidth,
      hasOverflow: el.scrollWidth > el.clientWidth + 1,
    };
    setBar((prev) =>
      prev.scrollWidth === next.scrollWidth && prev.hasOverflow === next.hasOverflow ? prev : next
    );
  }, []);

  useEffect(() => {
    const el = tableScrollRef.current;
    if (!el) return undefined;
    measureBar();
    const ro = new ResizeObserver(measureBar);
    ro.observe(el);
    if (el.firstElementChild) ro.observe(el.firstElementChild);
    window.addEventListener('resize', measureBar);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', measureBar);
    };
  }, [measureBar, sorted]);

  const onTableScroll = () => {
    if (headerRef.current && tableScrollRef.current) {
      headerRef.current.scrollLeft = tableScrollRef.current.scrollLeft;
    }
    if (syncing.current) { syncing.current = false; return; }
    if (barRef.current && tableScrollRef.current) {
      syncing.current = true;
      barRef.current.scrollLeft = tableScrollRef.current.scrollLeft;
    }
  };

  const onBarScroll = () => {
    if (syncing.current) { syncing.current = false; return; }
    if (barRef.current && tableScrollRef.current) {
      syncing.current = true;
      tableScrollRef.current.scrollLeft = barRef.current.scrollLeft;
    }
  };

  /* ───────── Handlers ───────── */
  const toggleSort = (key) =>
    setSort((prev) =>
      prev.key === key
        ? { key, dir: prev.dir === 'asc' ? 'desc' : 'asc' }
        : { key, dir: 'asc' }
    );

  const handleSelectAll = () => {
    if (allApprovableSelected) setSelectedRows([]);
    else setSelectedRows(approvableRows.map((r) => r.id));
  };

  const handleRowSelect = (rowId) => {
    setSelectedRows((prev) =>
      prev.includes(rowId) ? prev.filter((id) => id !== rowId) : [...prev, rowId]
    );
  };

  const handleApprove = (record) => {
    if (!record.otId) return;
    dispatch(approveOTRecord({
      employeeId: record.employeeId,
      overtimeId: record.otId,
      approvedBy: currentUserId,
    }));
    setSelectedRows((prev) => prev.filter((id) => id !== record.id));
  };

  const handleBulkApprove = () => {
    if (selectedRows.length === 0) return;
    const allRows = [...rows, ...pendingRows, ...approvedRows];
    const recordsById = new Map();
    allRows.forEach((r) => {
      if (r.HOT_OVERTIME_ID) recordsById.set(String(r.HOT_OVERTIME_ID), r);
    });
    const records = selectedRows.map((id) => {
      const r = recordsById.get(String(id));
      if (!r) return null;
      return { employeeId: r.HOT_EMPLOYEE_ID || '', overtimeId: r.HOT_OVERTIME_ID };
    }).filter(Boolean);
    if (records.length === 0) return;
    dispatch(bulkApproveOTRecords({ records, approvedBy: currentUserId }));
    setSelectedRows([]);
  };

  const handleExport = () => {
    exportOTRecordsToExcel({
      rows: sorted.map((row) => {
        const employee = employees.find(
          (emp) =>
            String(emp.employeeId) === String(row.employeeId) ||
            String(emp.serviceNo) === String(row.employeeId) ||
            String(emp.serviceNo) === String(row.serviceNo)
        );
        return {
          ...row,
          shiftType: row.shiftType || row.shiftName || employee?.shiftName || '',
        };
      }),
      filters: {
        'Employee ID': resolveEmployeeId() || 'All',
        'Employee Name':
          selectedEmployee && !isAllEmployees(selectedEmployee) ? selectedEmployee.name : 'All',
        Month: attMonth || 'All',
        Tab: activeTab,
        'OT Type': typeFilter,
        Search: search || 'None',
      },
    });
  };

  const isSearchDisabled = !employeeId.trim() && !attMonth.trim() && !selectedEmployee;
  const isBulkApproveDisabled = selectedRows.length === 0 || approving;
  const pendingCount = pendingRows.length;
  const approvedCount = approvedRows.length;

  /* ───────── Per-column cell renderer ───────── */
  const renderCell = (col, r) => {
    switch (col.key) {
      case 'select':
        return (
          <input
            type="checkbox"
            checked={selectedRows.includes(r.id)}
            onChange={() => handleRowSelect(r.id)}
            disabled={r.isApproved}
            className="rounded border-gray-300 text-primary-600 focus:ring-primary-500"
          />
        );
      case 'employeeName':
        return (
          <div className="flex items-center gap-2 min-w-0">
            <span className="font-medium text-gray-900 truncate" title={r.employeeName}>
              {r.employeeName || '—'}
            </span>
          </div>
        );
      case 'date':
        return <span className="text-gray-600">{r.date || '—'}</span>;
      case 'shiftName':
        return (
          <span
            className={
              (r.shiftName || '').trim() === 'Driver Shift'
                ? 'text-red-600 font-semibold'
                : 'text-gray-600'
            }
          >
            {r.shiftName || '—'}
          </span>
        );
      case 'otTypeLabel':
        return <span className="font-semibold text-gray-800">{r.otTypeLabel || '—'}</span>;
      case 'inTime':
      case 'outTime':
        return <span className="text-gray-600">{r[col.key] || '—'}</span>;
      case 'otHours':
        return (
          <span className="font-medium text-primary-700">
            {fmtH(r.otHours)}
          </span>
        );
      case 'HOT_OTHOURS_RATE':
        return <span className="font-medium text-primary-700">{Number(r.HOT_OTHOURS_RATE ?? 0).toFixed(2)}</span>;
      case 'HOT_ADJUSTED_OT_HOURS':
        return (
          <span className="font-medium text-primary-700">
            {fmtH(r.HOT_ADJUSTED_OT_HOURS)}
          </span>
        );
      case 'otRate':
        return <span className="text-gray-600">{Number(r.otRate ?? r.HOT_OT_RATE ?? 0).toFixed(2)}</span>;
      case 'otAmount':
        return <span className="font-medium text-gray-800">{Number(r.otAmount ?? r.HOT_OT_AMOUNT ?? 0).toFixed(2)}</span>;
      case 'status':
        return <StatusBadge isApproved={r.isApproved} />;
      case 'actions':
        if (r.isApproved) return <span className="text-xs text-gray-400">—</span>;
        return (
          <button
            onClick={() => handleApprove(r)}
            disabled={approving}
            className="inline-flex items-center justify-center gap-1 px-3 py-1 bg-blue-50 text-blue-600 rounded-lg text-xs font-medium hover:bg-blue-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {approving ? <Loader2 size={14} className="animate-spin" /> : <><CheckCircle size={14} />Approve</>}
          </button>
        );
      default:
        return r[col.key] ?? '—';
    }
  };

  return (
    <div className="p-6 space-y-4">
      <Breadcrumb
        trail={['Overtime Management', 'Overtime Details']}
        title="Overtime Details"
        action={
          <div className="flex items-center gap-2">
            {selectedRows.length > 1 && activeTab !== 'Approved' && (
              <button
                onClick={handleBulkApprove}
                disabled={isBulkApproveDisabled}
                className="flex items-center gap-2 h-9 px-4 bg-green-600 text-white rounded-lg text-xs font-semibold hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {approving ? <Loader2 size={14} className="animate-spin" /> : <Check size={14} />}
                Approve Selected ({selectedRows.length})
              </button>
            )}
            <button
              onClick={handleExport}
              disabled={sorted.length === 0}
              className={BREADCRUMB_EXPORT_BTN}
            >
              <FileSpreadsheet size={15} />
              Export to Excel
            </button>
          </div>
        }
      />

      {/* Filters */}
      <div className="bg-white border border-gray-100 rounded-xl px-4 py-3.5 shadow-sm space-y-3">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
          <div>
            <span className={LABEL}>Employee</span>
            <EmployeeSearch
              value={selectedEmployee}
              onSelect={setSelectedEmployee}
              employees={employees}
              loading={employeesLoading}
              showAllOption={true}
            />
          </div>
          <div>
            <span className={LABEL}>Date Filter</span>

            <div className="flex items-stretch gap-1.5">
              {/* Toggle — fixed width on the left */}
              <div className="inline-flex h-9 shrink-0 items-center rounded-lg bg-slate-100 p-0.5 ring-1 ring-inset ring-slate-200/60">
                {['month', 'range'].map((m) => (
                  <button
                    key={m}
                    type="button"
                    onClick={() => {
                      setDateMode(m);
                      if (m === 'range' && (!dateFrom || !dateTo)) {
                        const { from, to } = defaultRange();
                        setDateFrom(from);
                        setDateTo(to);
                      }
                    }}
                    className={`h-full rounded-md px-2.5 text-[10px] font-semibold transition-colors ${dateMode === m
                      ? 'bg-white text-slate-900 shadow-sm'
                      : 'text-slate-500 hover:text-slate-700'
                      }`}
                  >
                    {m === 'month' ? 'Month' : 'Range'}
                  </button>
                ))}
              </div>

              {/* Input(s) — fill the rest of the row */}
              <div className="min-w-0 flex-1">
                {dateMode === 'month' ? (
                  <input
                    type="month"
                    value={attMonth}
                    onChange={(e) => setAttMonth(e.target.value)}
                    className={FIELD}
                  />
                ) : (
                  <div className="grid grid-cols-2 gap-1.5">
                    <input
                      type="date"
                      value={dateFrom}
                      max={dateTo || undefined}
                      onChange={(e) => setDateFrom(e.target.value)}
                      className={FIELD}
                    />
                    <input
                      type="date"
                      value={dateTo}
                      min={dateFrom || undefined}
                      onChange={(e) => setDateTo(e.target.value)}
                      className={FIELD}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div>
            <span className={LABEL}>OT Type</span>
            <select
              value={typeFilter}
              onChange={(e) => setTypeFilter(e.target.value)}
              className={FIELD}
            >
              <option value="All">All</option>
              {typeOptions.map((t) => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>
          <div className="flex items-end gap-2">
            <button
              onClick={handleSearch}
              disabled={loading || isSearchDisabled}
              className="flex items-center gap-2 h-9 px-4 bg-primary-600 text-white rounded-lg text-xs font-semibold hover:bg-primary-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <Search size={14} />
              {loading ? 'Loading...' : 'Search'}
            </button>
            <button
              onClick={handleReset}
              className="flex items-center gap-2 h-9 px-3 bg-gray-100 text-gray-600 rounded-lg text-xs font-semibold hover:bg-gray-200 transition-colors"
            >
              <RotateCcw size={14} />
              Reset
            </button>
          </div>
        </div>

        <div className="flex items-center justify-between">
          {approvalError && <span className="text-xs text-red-600">{approvalError}</span>}
        </div>
      </div>

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
          {error}
        </div>
      )}

      {/* Tabs + Table card */}
      <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
        {/* Tab header*/}
        <div className="flex flex-col gap-3 border-b border-gray-100 p-5 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-[11px] text-slate-500">
          </div>

          <div className="flex gap-1 rounded-lg bg-surface-50 p-1">
            {TABS.map((tab) => {
              let count = 0;
              if (tab === 'Pending') count = pendingCount;
              else if (tab === 'Approved') count = approvedCount;
              else count = rows.length;
              return (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`rounded-md px-3.5 py-1.5 text-sm font-medium transition-colors ${activeTab === tab
                    ? 'bg-white text-primary-700 shadow-sm'
                    : 'text-gray-500 hover:text-gray-700'
                    }`}
                >
                  {tab}
                  <span className="ml-1.5 text-xs text-gray-400">({count})</span>
                </button>
              );
            })}
          </div>
        </div>

        {loading ? (
          <div className="flex items-center justify-center py-20">
            <Loader2 size={32} className="animate-spin text-primary-600" />
          </div>
        ) : (
          <>
            {/* ── Sticky header */}
            <div
              ref={headerRef}
              className="sticky z-30 overflow-hidden bg-gray-50"
              style={{ top: STICKY_TOP }}
            >
              <table
                className="border-separate border-spacing-0 text-sm"
                style={{ width: '100%', minWidth: TABLE_MIN_WIDTH, tableLayout: 'fixed' }}
              >
                <colgroup>
                  {COLUMNS.map((c) => <col key={c.key} style={{ width: c.width }} />)}
                </colgroup>
                <thead>
                  <tr>
                    {COLUMNS.map((c) => {
                      const sortKey = c.sortKey || c.key;
                      const active = sort.key === sortKey;
                      const SortIcon = !active
                        ? ChevronsUpDown
                        : sort.dir === 'asc'
                          ? ChevronUp
                          : ChevronDown;
                      const sortable = c.sortable !== false;
                      return (
                        <th
                          key={c.key}
                          style={stickyStyle(c)}
                          className={`${c.sticky ? 'sticky z-20' : ''} bg-gray-50 border-b border-gray-200 px-3 py-2.5
                                      text-[12px] font-semibold uppercase tracking-wide text-gray-500 select-none
                                      ${ALIGN[c.align]}`}
                          aria-sort={active ? (sort.dir === 'asc' ? 'ascending' : 'descending') : 'none'}
                        >
                          {c.key === 'select' ? (
                            <input
                              type="checkbox"
                              checked={allApprovableSelected}
                              onChange={handleSelectAll}
                              disabled={activeTab === 'Approved' || approvableRows.length === 0}
                              className="rounded border-gray-300 text-primary-600 focus:ring-primary-500"
                            />
                          ) : (
                            <span className="inline-flex items-center gap-1">
                              {sortable ? (
                                <button
                                  type="button"
                                  onClick={() => toggleSort(sortKey)}
                                  className="hover:text-gray-900"
                                  title={active ? `Sorted ${sort.dir === 'asc' ? 'ascending' : 'descending'} — click to toggle` : 'Click to sort'}
                                >
                                  {c.label}
                                </button>
                              ) : (
                                <span>{c.label}</span>
                              )}
                              {c.info && <InfoTip>{c.info}</InfoTip>}
                            </span>
                          )}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
              </table>
            </div>

            {/* ── Scrollable body*/}
            <div
              ref={tableScrollRef}
              onScroll={onTableScroll}
              className="relative overflow-x-auto [&::-webkit-scrollbar]:hidden"
              style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
            >
              <table
                className="border-separate border-spacing-0 text-sm"
                style={{ width: '100%', minWidth: TABLE_MIN_WIDTH, tableLayout: 'fixed' }}
              >
                <colgroup>
                  {COLUMNS.map((c) => <col key={c.key} style={{ width: c.width }} />)}
                </colgroup>
                <tbody>
                  {sorted.length === 0 && (
                    <tr>
                      <td
                        colSpan={COLUMNS.length}
                        className="px-5 py-10 text-center text-sm text-gray-400"
                      >
                        {activeTab === 'Pending' && pendingCount === 0
                          ? 'No pending OT records found'
                          : activeTab === 'Approved' && approvedCount === 0
                            ? 'No approved OT records found'
                            : 'No OT records found'}
                      </td>
                    </tr>
                  )}

                  {sorted.map((r, i) => (
                    <tr key={r.id || `row-${i}`} className="group">
                      {COLUMNS.map((c) => (
                        <td
                          key={c.key}
                          style={stickyStyle(c)}
                          className={`${c.sticky ? 'sticky z-10' : ''} bg-white group-hover:bg-gray-50
                                      border-b border-gray-100 px-3 py-2 overflow-hidden
                                      ${ALIGN[c.align]}`}
                        >
                          {renderCell(c, r)}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Footer summary */}
            {sorted.length > 0 && (
              <div className="flex items-center justify-between border-t border-gray-100 px-5 py-3">
                <span className="text-xs text-gray-500">
                  Showing <strong className="text-gray-800">{sorted.length}</strong>{' '}
                  {sorted.length === 1 ? 'entry' : 'entries'}
                </span>
              </div>
            )}

            {/* ── Sticky scrollbar */}
            <div
              ref={barRef}
              onScroll={onBarScroll}
              className="sticky z-30 overflow-x-auto overflow-y-hidden bg-white/95 border-t border-gray-200 rounded-b-xl"
              style={{
                bottom: STICKY_BOTTOM,
                height: 16,
                display: bar.hasOverflow && sorted.length > 0 ? 'block' : 'none',
              }}
              aria-hidden="true"
            >
              <div style={{ width: bar.scrollWidth, height: 1 }} />
            </div>
          </>
        )}
      </div>
    </div>
  );
}